export const resolveCurrentCustomerFlowStepIndex = ({
  flowConfig = [],
  stepStatuses = {}
}) => {
  if (!flowConfig.length || Object.keys(stepStatuses).length === 0) {
    return 0;
  }

  const inProgressIndex = flowConfig.findIndex(
    (stepName) => stepStatuses[stepName] === 'in_progress'
  );
  if (inProgressIndex !== -1) {
    return inProgressIndex;
  }

  const errorIndex = flowConfig.findIndex(
    (stepName) => stepStatuses[stepName] === 'error'
  );
  if (errorIndex !== -1) {
    return errorIndex;
  }

  const allStepsCompleted = flowConfig.every((stepName) => (
    stepStatuses[stepName] === 'completed' || stepStatuses[stepName] === 'processed'
  ));
  if (allStepsCompleted) {
    return flowConfig.length;
  }

  const pendingIndex = flowConfig.findIndex(
    (stepName) => stepStatuses[stepName] === 'pending'
  );
  if (pendingIndex !== -1) {
    return pendingIndex;
  }

  for (let index = flowConfig.length - 1; index >= 0; index -= 1) {
    const status = stepStatuses[flowConfig[index]];
    if (status === 'completed' || status === 'processed') {
      return Math.min(index + 1, flowConfig.length);
    }
  }

  return 0;
};
